import { BoxProps, Button, ShorthandValue } from "@fluentui/react-northstar";
import { SurveyDTO } from "@teams/types/api";
import React from "react";

import { startMeetingSurveyTakingTask } from "../../../../_shared/utils/startTaskWrapper";

type AnswerSurveyButtonProps = {
  label: string;
  survey: SurveyDTO;
  onResponded: () => void;
  icon?: ShorthandValue<BoxProps>;
  fluid?: boolean;
};

export const AnswerSurveyButton: React.FC<AnswerSurveyButtonProps> = ({
  label,
  survey,
  onResponded,
  icon,
  fluid,
}) => {
  return (
    <Button
      secondary
      content={label}
      icon={icon}
      fluid={fluid}
      onClick={async () => {
        await startMeetingSurveyTakingTask(survey);
        onResponded();
      }}
    />
  );
};
